import { render } from "./ToReport.vue?vue&type=template&id=2d4741a8"
import script from "./ToReport.vue?vue&type=script&lang=js"
export * from "./ToReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__